import React, {useEffect, useRef} from 'react';
import {useNavigate, useParams} from 'react-router-dom';
import {usePrevious} from 'react-use';
import {
  selectRoomState,
  HMSRoomState,
  selectIsConnectedToRoom,
  useHMSActions,
  useHMSStore,
} from '@100mslive/react-sdk';
import {Box, Flex} from '@100mslive/roomkit-react';
import './100-ms-style-override.css';
// import { Header } from "./Header";
// import { Footer } from "./Footer";

// import { RoleChangeRequestModal } from "./RoleChangeRequestModal";

import {useIsHeadless} from './AppData/useUISettings';
import FullPageProgress from './UI-Components/FullPageProgress';
import {ConferenceMainView} from './layouts/mainView';
import {Header} from './Header';
import {Footer} from './Footer';
import useWindowDimensions from './windowDimension';
// import {Footer} from './Footer';

const Conferences = ({meetingUrl}: any) => {
  // const navigate = useNavigate();
  const {roomId, role} = useParams();
  const isHeadless = useIsHeadless();
  const roomState = useHMSStore(selectRoomState);
  const prevState = usePrevious(roomState);
  const isConnectedToRoom = useHMSStore(selectIsConnectedToRoom);
  const hmsActions = useHMSActions();
  const { height, width } = useWindowDimensions();
  const [isMobileScreen] = [width <= 440];
  const [isIPad] = [height >= 1024 && height <= 1366];

  useEffect(() => {
    if (false) {
      // if (!roomId) {
      //   navigate(`/`);
      //   return;
      // }
      // if (
      //   !prevState &&
      //   !(roomState === HMSRoomState.Connecting || isConnectedToRoom)
      // ) {
      //   if (role) navigate(`/preview/${roomId || ''}/${role}`);
      //   else navigate(`/preview/${roomId || ''}`);
      // }
    }
  }, [isConnectedToRoom, prevState, roomState, role, roomId]);

  useEffect(() => {
    return () => {
      // This is needed to handle mac touchpad swipe gesture
      if (isConnectedToRoom && false) {
        hmsActions.leave();
      }
    };
  }, []);
  // }, [hmsActions, isConnectedToRoom]);

  if (!isConnectedToRoom) {
    return <FullPageProgress />;
  }

  return (
    <Flex css={{flex: 1, size: '100%'}} direction="column">
      {(!isHeadless || true) && (
        <Box css={{h: '$18', '@md': {h: '$17'}}} data-testid="header">
          <Header />
        </Box>
      )}
      <Box
        css={{
          w: '100%',
          flex: isIPad ? .65 : '1 1 0',
          minHeight: 0,
          '@md': {
            marginBottom: !(isIPad || isMobileScreen) ? 140 : undefined,
            overflow: 'scroll',
          },
        }}
        data-testid="conferencing">
        <ConferenceMainView />
      </Box>
      {!isHeadless && (
        <>
          {isMobileScreen ? <>
            <Box
              css={{
                backgroundColor:'#1C1C1C',
                flexShrink: 0,
                minHeight: '$20',
                px:16,
              }}
              data-testid="footer"
            >
              <Footer meetingUrl={meetingUrl} isMobile={true} />
              {/* `Footer ` */}
            </Box>
          </> : <Box
            css={{
              flex: isIPad ? .35 : undefined,
              flexShrink: 0,
              minHeight: '$24',
              '@md': {
                marginBottom: 120,
                position: 'fixed',
                bottom: '0',
                width: '100%',
              },
            }}
            data-testid="footer">
            <Footer meetingUrl={meetingUrl} />
            {/* `Footer ` */}
          </Box>}
        </>
      )}
      {/* <RoleChangeRequestModal /> */}
    </Flex>
  );
};

export default Conferences;
